/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/StatusType
 * @desc Filter ExperimentWorkflow by status type
 */

import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import FilterStatusTypeForm from './Form';
import type { FilterPostNewIndexStatusTypeProps } from './types';

export const FilterPostNewIndexStatusType: React.FC<
  FilterPostNewIndexStatusTypeProps
> = ({ addPostFilter, defaultValues, ...rest }) => (
  <Modal
    header={`Filter by Status Type`}
    viewComponent={({ toggleModal }): React.ReactNode => (
      <ActionComponent
        onClick={toggleModal}
        type="option"
        icon={ICONS.metadata.secondary}
        text="Filter by this field"
      />
    )}
    content={({ toggleModal }): React.ReactNode => (
      <FilterStatusTypeForm
        addPostFilter={addPostFilter}
        defaultValues={defaultValues}
        onDone={toggleModal}
      />
    )}
    {...rest}
  />
);
